<template>
<div class="project__list">
    <ul>
      <li v-for="(item, index) in items" v-bind:key="item.id" :class="item.id === selectedProject.id ? 'selected-li' : ''" >
        <div class="project__list__item" :class="item.id === selectedProject.id ? 'selected-item' : ''" title="Select project" @click="!item.edit ? onSetProject(item) : ''">
          <div v-if="!item.edit" class="title"><span>{{item.title !== undefined ? item.title.substring(0, 25) : ''}}</span></div>
          <input class="title" ref="nameInput" v-if="item.edit" name="title" type="text" placeholder="Title" v-model="item.title" @keyup.enter="save(item)" />
          <button v-if="!item.edit" class="button save" title="rename project" @click.stop="rename(item, index)"><i class="material-icons">edit</i></button>
          <button v-if="item.edit" style="margin-left: 10px" class="button" title="Close" @click.stop="item.edit=false"><i class="material-icons">close</i></button>
          <button v-if="item.edit" title="Save" class="button save" @click="save(item)"><i class="material-icons">save</i></button>
          <div class="date"><span>{{formateDate(item)}}</span></div>
          <div class="actions">
            <button class="button clone" title="Clone" @click.stop="cloneItem(item.id)"><i class="material-icons">file_copy</i></button>&nbsp;
            <button class="button delete" title="Delete" @click.stop="project=item,showConfirm()"><i class="material-icons">delete</i></button>
          </div>
        </div>
        <edit @close="onSetProject(item)" v-if="selectedProject.visible && item.id === selectedProject.id" :item="selectedProject"></edit>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Edit from './edit'

export default {
  name: 'list',
  props: ['items'],
  computed: {
    ...mapGetters(['selectedProject', 'selectedAsset'])
  },
  data: () => ({
    project: null
  }),
  components: { Edit },
  methods: {
    ...mapActions(['setProject', 'deleteProject', 'cloneProject', 'saveProject', 'unsetAsset']),
    cloneItem(id) {
      this.cloneProject(id)
    },
    showConfirm() {
      const options = {title: `DELETE PROJECT`, cancelLabel: 'NO', okLabel: 'YES'}
      this.$dialogs.confirm(`Do you really want to delete the project: ${this.project.title.toUpperCase()}?`, options)
      .then(res => {
        if (res.ok) {
          this.deleteProject(this.project)
          if (this.selectedAsset.projectId === this.project.id){
            this.unsetAsset()
          }
        }
      })
    },
    formateDate(item) {
      return new Date(item.updatedDate !== undefined ? item.updatedDate : item.createdDate).toLocaleString('de-CH')
    },
    rename: function(item,index) {
      item.edit=true
      this.$nextTick(() => {
        let inputEl = this.$refs.nameInput[index]
        if (inputEl) {
          inputEl.focus()
        }
      })
    },
    save: function(item) {
      this.saveProject(item).then(() => {
      });
    },
    onSetProject(item) {
      if (item === this.selectedProject) {
        return
      }
      this.unsetAsset()
      this.setProject(item)
    }
  }
}
</script>
